import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { Store } from '@ngxs/store';
import { ShowErrorNotification, SimpleRouterState } from '@platform-frontend/util';
import { MSG_DISABLED_ACTION_WITH_DISABLED_ACCOUNT } from '../notification-messages';
import { SessionState } from '../session';

export const AccountEnabledGuard: CanActivateFn | CanActivateChildFn = () => {
  const store = inject(Store);
  if (store.selectSnapshot(SessionState.isDisabled) !== false && store.selectSnapshot(SimpleRouterState.guardsActivated)) {
    store.dispatch(new ShowErrorNotification(MSG_DISABLED_ACTION_WITH_DISABLED_ACCOUNT));
    return false;
  } else {
    return true;
  }
};
